import React, { FC } from 'react';
import { Field } from 'redux-form';
import { ToggleExtra } from '@common/components/Extras/controls';
import QuantityPicker from '@common/components/QuantityPicker';
import { ButtonWrapper, ToggleExtraButton } from './PerStay.styles';

export const PerStay: FC<{ id: number; maxQuantity: number | null }> = ({ id, maxQuantity }) => (
  <ButtonWrapper>
    {!!maxQuantity && (
      <Field component={QuantityPicker} name={`extras.${id}.quantity`} maxValue={maxQuantity} />
    )}
    <ToggleExtraButton>
      <Field name={`extras.${id}.isSelected`} component={ToggleExtra} />
    </ToggleExtraButton>
  </ButtonWrapper>
);
